import * as Yup from 'yup';
import { getRequiredText } from '../../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { PensionEnrollmentProps } from '../../../models/arc-epi-props';
import { PensionEnrollmentContributionType, PensionEnrollmentStep } from './pension-enrollment-model';

export interface PensionEnrollmentFormValues {
    plan: string;
    bill_payer: string;
    effective_date_month: number;
    effective_date_year: number;
    contribution_type: PensionEnrollmentContributionType;
    contribution_amount: number | string;
    agreement: boolean;
}

export function pensionEnrollmentValidationSchema(labelSetting: LabelSettingProps, pensionProps: PensionEnrollmentProps, step: PensionEnrollmentStep) {
    let schema = Yup.object().shape({});

    if (step === PensionEnrollmentStep.Detail) {
        schema = schema.shape({
            bill_payer: Yup.string().required(getRequiredText(labelSetting.requiredFormat, pensionProps?.billingOrgLabel)),
            effective_date_month: Yup.number().nullable().required(getRequiredText(labelSetting.requiredFormat, pensionProps?.monthLabel)),
            effective_date_year: Yup.number().nullable().required(getRequiredText(labelSetting.requiredFormat, pensionProps?.yearLabel)),
            contribution_amount: Yup.number().round('floor').moreThan(-1, labelSetting.notNegative),
        });
    }
       
    return schema;
}